// Calls the groqChatCompletion Cloud Function (shared with the mobile app's
// services/groqClient.ts). The Groq key lives only in the function's
// environment, never in the web bundle.
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebase";

let callable = null;

export async function groqChatCompletion(params) {
  if (!callable) callable = httpsCallable(getFunctions(app), "groqChatCompletion");
  const result = await callable(params);
  return result.data?.content;
}
